module.exports = __webpack_public_path__ + "img/entrance_plant_3@3x.4a63ba58.jpg";